module.exports = __webpack_public_path__ + "img/top1.b30be981.png";